import { defineNuxtPlugin } from "nuxt/app";
import { ElLoading } from "element-plus";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("loading", ElLoading.directive);
});
